import { FontWeight, Heading } from '@lili/lili-frontend-common';

interface IProps {
  activeStep: number;
  numberOfSteps: number;
  docTitle: string;
}

export const Header = ({ activeStep, numberOfSteps, docTitle }: IProps) => {
  return (
    <>
      <Heading.H10 id='BVC__stepper' className='text-text-main-secondary mb-[16px] '>
        Step {activeStep + 1} / {numberOfSteps}
      </Heading.H10>
      <Heading.H5 id='required-doc__title' className='mb-[16px]' fontWeight={FontWeight.SEMIBOLD}>
        {docTitle}
      </Heading.H5>
    </>
  );
};
